var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"g24-btn",class:{
  'g24-btn_active': _vm.active,
  'g24-btn_full-width': _vm.fullWidth,
},on:{"click":_vm.click}},[_c('span',[_vm._t("default",[_vm._v(_vm._s(_vm.name))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }